// Shows the sticky buy bar once the visitor scrolls past the main product
// form's Add to Cart button. Falls back to always-visible if that button
// can't be found (e.g. section removed), rather than hiding purchase entirely.
(function () {
  var bar = document.getElementById("sticky-atc");
  if (!bar) return;

  var button = document.getElementById("sticky-atc-button");
  var mainForm = document.querySelector(
    'product-form form[action^="/cart/add"], form[action^="/cart/add"]'
  );

  function showBar() {
    bar.classList.add("sticky-atc--visible");
  }
  function hideBar() {
    bar.classList.remove("sticky-atc--visible");
  }

  if (mainForm && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            hideBar();
          } else if (entry.boundingClientRect.top < 0) {
            // main button has scrolled above the viewport
            showBar();
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainForm);
  } else {
    // no main form found on this page layout — show after a short scroll
    window.addEventListener(
      "scroll",
      function () {
        if (window.scrollY > 400) showBar();
        else hideBar();
      },
      { passive: true }
    );
  }

  if (button) {
    button.addEventListener("click", function () {
      var variantId = button.getAttribute("data-variant-id");
      if (!variantId) return;

      button.disabled = true;
      var originalText = button.textContent;
      button.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error("Add to cart failed");
          return res.json();
        })
        .then(function () {
          button.textContent = "Added ✓";
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          setTimeout(function () {
            window.location.href = "/cart";
          }, 500);
        })
        .catch(function () {
          button.textContent = "Try again";
          button.disabled = false;
        })
        .finally(function () {
          setTimeout(function () {
            if (!button.disabled) return;
            button.disabled = false;
            button.textContent = originalText;
          }, 2000);
        });
    });
  }
})();
